import React, { useState, useEffect, useRef } from "react";
import { ChevronDown, Search, Check } from "lucide-react";
import { DEFAULT_THEME } from "../constants/theme";

export default function CustomSelect({ options, value, onChange, placeholder = "선택하세요", className, showSearch = true, triggerClassName, theme = DEFAULT_THEME }) {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const containerRef = useRef(null);

    const selectedOption = options.find(opt => opt.value === value);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const filteredOptions = options.filter(opt =>
        opt.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className={`relative ${className}`} ref={containerRef}>
            <div
                className={triggerClassName ?
                    `${triggerClassName} cursor-pointer flex justify-between items-center ${isOpen ? `ring-4 ${theme.bg.replace("bg-", "ring-")}/10 ${theme.border}` : ""}`
                    : `
            w-full border-2 p-2.5 pl-4 rounded-[2rem] bg-[#F9F9F8] cursor-pointer flex justify-between items-center transition
            ${isOpen ? `${theme.border} bg-white ring-2 ${theme.bg.replace("bg-", "ring-")}/10` : "border-[#EAEAEA] hover:border-gray-300"}
        `}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className={`font-bold text-sm ${selectedOption ? "text-gray-900" : "text-gray-400"}`}>
                    {selectedOption ? selectedOption.label : placeholder}
                </span>
                <ChevronDown size={16} className={`text-gray-400 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} />
            </div>

            {isOpen && (
                <div className="absolute top-full left-0 mt-2 w-full bg-white rounded-[2rem] shadow-xl border border-gray-100 p-2 z-50 max-h-[300px] flex flex-col">
                    {showSearch && (
                        <div className="px-2 pb-2 mb-2 border-b border-gray-100 sticky top-0 bg-white z-10">
                            <div className="relative">
                                <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                <input
                                    type="text"
                                    placeholder="검색..."
                                    className="w-full bg-gray-50 rounded-xl py-2 pl-9 pr-3 text-xs font-bold outline-none focus:bg-gray-100 transition"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    onClick={(e) => e.stopPropagation()}
                                    autoFocus
                                />
                            </div>
                        </div>
                    )}

                    <div className="overflow-y-auto custom-scrollbar flex-1">
                        {filteredOptions.length === 0 ? (
                            <div className="py-4 text-center text-xs text-gray-400 font-bold">검색 결과가 없습니다.</div>
                        ) : (
                            filteredOptions.map((opt) => (
                                <div
                                    key={opt.value}
                                    onClick={() => { onChange(opt.value); setIsOpen(false); setSearchTerm(""); }}
                                    className={`
                                px-3 py-2.5 rounded-xl text-sm font-bold cursor-pointer flex justify-between items-center transition mb-1
                                ${value === opt.value ? `${theme.bg} text-white` : "text-gray-600 hover:bg-gray-50"}
                            `}
                                >
                                    {opt.label}
                                    {value === opt.value && <Check size={14} />}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
